module.exports = __webpack_public_path__ + "assets/img/skill_bg.e9c7ef23.png";